
export default {
  data() {
    return {
      panel: 1,
      faq: [
        {
          title: 'Should I ask my Property Agent to Manage my Rental Property?',
          text: 'Many property Agents in Thailand also manage investment property.  But management is a profession that required strong ethics and experience.  If your Agent uses Properlly software to manage client’s investment properties, you can rest assured that they understand the management business and take their duty seriously.',
        },
        {
          title:
            'How do I find a property agent or manager that uses Properlly software? ',
          text: 'It’s easy.  Visit Properlly.com and click on the “Recommend” tab at the top of the page.  Then select your area from the map and a list of qualified Property Managers are available for you to select.',
        },
        {
          title: 'What makes Properlly managers better than other managers?',
          text: 'Properlly managers and agents are full-time professionals who take their jobs seriously.  When we demo Properlly, we screen them to ensure they have the skills, local knowledge, and proven track record of customer success necessary to make your investment experience go smoothly.  Properlly also offers continuing education and networking for our family of managers.',
        },
        {
          title: 'Why is the Properlly website green?',
          text: 'According to an article by Nicole Martins Ferreira in the 31 May, 2019 edition of Oberlo, green is associated with growth, money, generosity, stability, and nature.  Many of our valued clients use these words to describe Properlly.',
        },
        {
          title: 'Why are there no short-term rentals?',
          text: 'Thailand prohibits renting of multi-family units for less than 1 month.  While independent villas can be an exception, our platform is not ready to accept vacation/short-term rentals yet.  Please check back periodically to see if we have added this feature.',
        },
        {
          title: 'How-to view a property that is listed for Rent?',
          text: 'Properties that are available (and available soon) are listed for rent on Properlly.com.  Simply click the home page and scroll down to the Search bar or the “Featured” section. <br/> When you have found a property that you are interested in viewing or connecting with an agent, there are a few options on the page: <br/><ul><li>Apply to Rent</li><li>Request a Tour in person or by video</li><li>Contact the Agent to ask a Question or get more Info</li></ul><br/>Just click on your choice and submit your information.  The Agent will contact you shortly.',
        },
        {
          title:
            'Does Properlly have their own Property Managers or Property Agents?',
          text: 'No.  We are an IT company.  Our founder has over 40 years of property management experience in the United States and Thailand.  We believe it is best to assist our customers… not a team of managers or agents.  The customer always comes first at Properlly.',
        },
        {
          title: 'Why are you located in Thailand?',
          text: 'The company founder moved to Thailand about 1999.  He loves this Kingdom and the greater SE Asia region.',
        },
        {
          title: 'Will you expand outside Thailand?',
          text: 'Yes.  We have plans to grow across SE Asia and into the Middle East in the next few years.',
        },
      ],
    }
  },
}
